import { render, staticRenderFns } from "./DeleteQuestionDialog.vue?vue&type=template&id=4cbd8a0c"
import script from "./DeleteQuestionDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports